"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (virtual) { return function (data) {
    var raw = (data.raw || '').slice(8, -2);
    return { raw: raw };
}; });



// WEBPACK FOOTER //
// ./src/decode/jsonTransparentNotCheckRaw.ts